// extracted by mini-css-extract-plugin
export default {"rating":"pG-z","numberOfStars":"qG-z","count":"rG-z","barGraphSpacing":"sG-z","barGraph":"tG-z"};